function markerIcon(color, opacity) {
  return {
      path: 'M5.99948555,0 C9.30738232,0 12,2.64651274 12,5.9000238 C12,6.78618411 11.5639468,8.00750084 10.9334148,9.31029951 L10.6714025,9.83516338 L10.6714025,9.83516338 L10.3920814,10.3651108 C10.3442764,10.4536586 10.2958933,10.5422679 10.2470038,10.6308635 L9.94816178,11.1616717 L9.94816178,11.1616717 L9.64060038,11.6885439 L9.64060038,11.6885439 L9.32775535,12.2078724 L9.32775535,12.2078724 L9.01306242,12.7160493 L9.01306242,12.7160493 L8.54507386,13.4495134 L8.54507386,13.4495134 L8.09225349,14.1375924 L8.09225349,14.1375924 L7.66619687,14.7681101 L7.66619687,14.7681101 L7.0470717,15.657987 L7.0470717,15.657987 L6.32461631,16.6560343 L6.1085484,16.9463818 C6.08282603,16.9797667 6.04269913,17 5.99948555,17 C5.97136243,17 5.94415388,16.9910074 5.92151819,16.9751206 L5.8914516,16.9463818 L5.25092541,16.0754787 L5.25092541,16.0754787 L4.46787032,14.9633867 L4.46787032,14.9633867 L3.90774651,14.1375924 L3.90774651,14.1375924 L3.45492614,13.4495134 L3.45492614,13.4495134 L2.98693758,12.7160493 L2.98693758,12.7160493 L2.51537641,11.9493766 L2.51537641,11.9493766 L2.20474373,11.4258253 C2.15345964,11.3379882 2.10246728,11.2499119 2.05183822,11.1616717 L1.75299617,10.6308635 C1.70410665,10.5422679 1.65572359,10.4536586 1.60791857,10.3651108 L1.32859754,9.83516338 L1.32859754,9.83516338 L1.06658518,9.31029951 C0.436053233,8.00750084 0,6.78618411 0,5.9000238 C0,2.64651274 2.69158879,0 5.99948555,0 Z M6,3.5 C4.62254667,3.5 3.5,4.62134993 3.5,6 C3.5,7.37745333 4.62254667,8.5 6,8.5 C7.37865007,8.5 8.5,7.37745333 8.5,6 C8.5,4.62134993 7.37865007,3.5 6,3.5 Z',
      anchor: new google.maps.Point(6,17),
      fillOpacity: opacity || 1,
      fillColor: color,
      strokeWeight: 0,
      scale: 3
  };
}

window.initMap = function() {
  var maps = document.querySelectorAll('.js-google-map');
  maps.forEach(map => {
    var markers = map.querySelectorAll('.js-google-marker');
    maps.innerHtml = '';

    var center = map.attributes['data-center'].value;
    if(/^[0-9.\-,]+$/.test(center)) {
      var centerVals = center.split(',').map(parseFloat);
      center = { lat: centerVals[0], lng: centerVals[1] };
    }
    var style = map.attributes['data-style'].value;
    if(style) {
      try {
        style = JSON.parse(style);
      } catch(err) { /* ignore */ }
    }

    var mapTmp = new google.maps.Map(map, {
      zoom: parseInt(map.attributes['data-zoom'].value) || 13,
      center: center,
      styles: style,
      disableDefaultUI: true,
      clickableIcons: false,
      keyboardShortcuts: false,
      gestureHandling: 'none'
    });
  
    markers.forEach(marker => {
      var center = marker.attributes['data-center'].value;
      var color = marker.attributes['data-color'].value;

      if(/^[0-9.\-,]+$/.test(center)) {
        var centerVals = center.split(',').map(parseFloat);
        center = { lat: centerVals[0], lng: centerVals[1] };
      }

      new google.maps.Marker({
        position: center,
        map: mapTmp,
        icon: markerIcon(color)
      });    
    });
  });
}